import { EmailImportance } from "client/Api/Email/common";
import { EmailActions } from "client/Api/Email/email";
import { isNotNilOrEmpty } from "client/Misc/utils";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";
import { EmailDate } from "../EmailDate/EmailDate";
import { EmailHeaderDetails } from "../EmailHeaderDetails/EmailHeaderDetails";
import { RecipientList } from "../RecipientList/RecipientList";
import styles from "./MobileAndDesktopHeaderDetails.module.less";
import { TimeZone } from "client/DateAndTime/timezones";

export type MobileAndDesktopHeaderDetailsProps = {
	isMobile: boolean;
	showFullHeaderDetails: boolean;
	cc: string;
	hasInlineImages: boolean;
	shouldAllowInlineImages: boolean;
	onAllowInlineImages(): void;
	importance: EmailImportance;
	lastAction: EmailActions;
	lastActionDateTime: string | Date | null;
	to: string;
	from: string;
	receivedDateTime: string | Date | null;
	timezone: TimeZone;
};

export const MobileAndDesktopHeaderDetails = (props: MobileAndDesktopHeaderDetailsProps): ReactElement => {
	const {
		isMobile,
		showFullHeaderDetails,
		cc,
		hasInlineImages,
		shouldAllowInlineImages,
		onAllowInlineImages,
		importance,
		lastAction,
		lastActionDateTime,
		to,
		from,
		receivedDateTime,
		timezone
	} = props;

	return(
		<div className={styles.root}>
			<div>
				{isMobile
					? (
						<MobileHeaderDetails
							from={from}
							isMobile={isMobile}
							to={to}
							showFullHeaderDetails={showFullHeaderDetails}
						/>
					) : (
						<EmailHeaderDetails
							onAllowInlineImages={onAllowInlineImages}
							cc={cc}
							hasInlineImages={hasInlineImages}
							importance={importance}
							lastAction={lastAction}
							lastActionDateTime={lastActionDateTime}
							shouldAllowInlineImages={shouldAllowInlineImages}
							isMobile={isMobile}
							to={to}
							showFullHeaderDetails={showFullHeaderDetails}
							receivedDateTime={receivedDateTime}
							timezone={timezone}
						/>
					)
				}
			</div>
			{
				!showFullHeaderDetails && (
					<div className={styles.emailDate}>
						<EmailDate
							value={receivedDateTime}
							timezone={timezone}
						/>
					</div>
				)
			}
		</div>
	);
};
MobileAndDesktopHeaderDetails.displayName = "MobileAndDesktopHeaderDetails";


type MobileHeaderDetailsProps = {
	isMobile: boolean;
	showFullHeaderDetails: boolean;
	to: string;
	from: string;
};

const MobileHeaderDetails = (props: MobileHeaderDetailsProps): ReactElement => {
	const {
		isMobile,
		showFullHeaderDetails,
		to,
		from
	} = props;

	return (
		<>
			{showFullHeaderDetails
				? (
					<div className={styles.from}>
						&lt;
						{isNotNilOrEmpty(from) ? from : <>&hellip;</>}
						&gt;
					</div>
				)
				: (
					<RecipientList
						value={to}
						wrappingBehavior={(isMobile && !showFullHeaderDetails) ? "ellipsis" : "wrap"}
						trackingId="to"
						label={localize("_To")}
					/>
				)
			}
		</>
	);
};
MobileHeaderDetails.displayName = "MobileHeaderDetails";